/**
 * External links to the Addy marketing site, support docs, and legal pages.
 *
 * Addy is the platform brand (addy.vn). HIS is one product under it.
 *
 *   addy.vn          → platform marketing landing
 *   addy.vn/his      → HIS product page (pricing, demo request, ROI calculator)
 *   addy.vn/his/dang-ky → contact-sales form for clinics interested in HIS
 *
 * App-internal flows: provisioning is sales-led, not self-serve. Clinic owners
 * fill the dang-ky form on the marketing site → CS contacts them → contract +
 * KYB → CS creates the tenant in HIS → owner receives /accept-invite link.
 *
 * Keep all external URLs in this file so domain changes (rebrand, locale,
 * etc.) require touching exactly one place.
 */

const MARKETING_BASE = "https://addy.vn";

export const EXTERNAL_LINKS = {
  // Marketing — sales-led acquisition
  marketingHome: `${MARKETING_BASE}`,
  hisProductPage: `${MARKETING_BASE}/his`,
  hisContactSales: `${MARKETING_BASE}/his/dang-ky`,
  hisPricing: `${MARKETING_BASE}/his/bang-gia`,

  // Support
  helpCenter: `${MARKETING_BASE}/ho-tro`,
  contactSupport: `${MARKETING_BASE}/lien-he`,

  // Legal
  privacy: `${MARKETING_BASE}/quyen-rieng-tu`,
  terms: `${MARKETING_BASE}/dieu-khoan`,

  // Status / system
  statusPage: `${MARKETING_BASE}/status`,
} as const;
